module.exports = __webpack_public_path__ + "img/video-simply-1.c487e1e5.png";